var map = {
	"./DesignHome.vue": "1157",
	"./TheMainFooter.vue": "842b",
	"./TheMainHeader.vue": "938a",
	"./TheMainMenuItem.vue": "d8e0",
	"./TheMainSubMenu.vue": "3740",
	"./components/DesignComponentsBadge.vue": "e5a2",
	"./components/DesignComponentsButton.vue": "92fa",
	"./components/DesignComponentsControl.vue": "208b",
	"./components/DesignComponentsDropdown.vue": "11a8",
	"./components/DesignComponentsForm.vue": "ac32",
	"./components/DesignComponentsHeader.vue": "5611",
	"./components/DesignComponentsModal.vue": "0285",
	"./components/DesignComponentsPagination.vue": "096b9",
	"./components/DesignComponentsProductData.vue": "c77f",
	"./components/DesignComponentsReviewData.vue": "b365",
	"./components/DesignComponentsThumbnail.vue": "dcad",
	"./foundations/DesignFoundationsColor.vue": "b965",
	"./foundations/DesignFoundationsIconography.vue": "bad4",
	"./foundations/DesignFoundationsMotion.vue": "80b9",
	"./foundations/DesignFoundationsSpacing.vue": "c90a",
	"./foundations/DesignFoundationsTypography.vue": "dea7",
	"./foundations/DesignFoundationsWritings.vue": "9762",
	"./get_started/DesignGetStartedIntroduction.vue": "22e2",
	"./get_started/DesignGetStartedPrinciples.vue": "b892"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a01b";